import RedirectForbidden from '@app/permissions/RedirectForbidden';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';
import { Spinner } from '@servicetitan/design-system';
import React from 'react';

interface RequireFeatureProps {
  children: React.ReactNode;
  flagName: FeatureFlagKeys;
  showWaitSpinner?: boolean;
  shouldRedirectIfDisabled?: boolean;
}

/**
 * Render child components only if the specified feature flag is enabled.
 *
 *
 */
const RequireFeature: React.FC<RequireFeatureProps> = ({
  children,
  flagName,
  showWaitSpinner = false,
  shouldRedirectIfDisabled = false,
}) => {
  const { [flagName]: featureFlagValue } = useFeatureFlags();

  // Do not show the feature-flagged children while the feature's loading.
  if (featureFlagValue === undefined) {
    if (showWaitSpinner) {
      return <Spinner />;
    }

    return;
  }

  if (!featureFlagValue) {
    // If the feature is not enabled, forbid access to the page.
    if (shouldRedirectIfDisabled) {
      return <RedirectForbidden />;
    }

    return;
  }

  return <>{children}</>;
};

export default RequireFeature;
